<template>
  
  <div>
    <index-card>
      <template slot="header">
        <div class="d-flex align-center">
          <v-btn text icon large to="/" exact><v-icon class="white--text">mdi-arrow-left</v-icon></v-btn>
          <v-btn color="white" class="blue-grey--text elavation-0 font-weight-bold my-1 mx-1" @click="$router.push({name: 'DriverRegister'})" center>
            <v-icon small left>mdi-plus</v-icon>Motorista
          </v-btn>
        </div>
        <span class="headline white--text">
          Motoristas 3º e Transportadoras
        </span>
        <div class="d-flex align-center">
          <BtnCreateDataExport api_model="Driver" class="my-1 mx-1" action="Drivers" clas></BtnCreateDataExport>
          <v-btn text icon @click="getData()" exact><v-icon class="white--text">mdi-refresh</v-icon></v-btn>
        </div>
      </template>
      <template slot="subheader">
        <div class="drivers-list-filters">
          <filter-data
            :with_client="false"
            :with_date_start="false"
            :with_date_end="false"
            with_text_search
            text_search_label="Pesquise.."
            :loading_block="loading"
            @doneFilter="handleDoneFilter"
          />
        </div>
      </template>
      <template slot="data_table">

        <v-data-table 
          @click:row="editItem" 
          :headers="headers" 
          :items="all_drivers" 
          class="elevation-4"
          :search="search"
          :options.sync="pagination"
          :loading="loading"
          :server-items-length="total_drivers"
          mobile-breakpoint="1"
        >
          <template v-slot:no-results>
            <v-alert :value="true" type="error" icon="mdi-alert" class="my-3">
              Não foi possível encontrar "{{ search }}" nos motoristas.
            </v-alert>
          </template>
        </v-data-table>
  
      </template>
    </index-card>
    <router-view></router-view>

  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { mapState } from 'vuex';
import Api from '@/api/index'

export default {
  name: 'DriversList',
  components: {
    BtnCreateDataExport: () => import('@/components/data_export/BtnCreateDataExport.vue'),
    IndexCard: () => import("@/_backoffice/_registrations/components/shared/index/IndexCard.vue"),
    EditDriver: () => import("./EditDriver.vue"),
    FilterData: () => import('@/components/shared/FilterData.vue'),
  },
  data() {
    return {
      search: '',
      headers: [
        { text: 'Nome', value: 'name', align: 'center' },
        { text: 'CNH', value: 'cnh', align: 'center' },
      ],
      pagination: {
        page:1,
        itemsPerPage: 10,
        sortBy:['name'],
        sortDesc:[true],
        groupBy:[],
        groupDesc:[],
        mustSort:false,
        multiSort:false,
      },
      filters:[
        {text:"Todos", value: {}},
        {text:"Internos", value: { external: false }},
        {text:"Externos", value: { external: true }},
      ],
      local_filter: {},

      dialog: false,
      letEdit: false,

      all_drivers: [],

      loading: false,
      total_drivers: 0, 

      aux_modality_id: null
    }
  },
  computed: mapState({
    oneDriver: state => state.Driver.oneDriver,
  }),
  methods: {
    getData(){
      this.getDrivers(true)
    },
    handleDoneFilter(filter = {}) {
      this.search = filter.query ? String(filter.query) : ''
      this.getDrivers(true)
    },
    getDrivers(reset_page = false){
      if(this.activeModalityId){
        this.loading = true
  
        const { sortBy, sortDesc, page, itemsPerPage } = this.pagination
        let params = {
          page,
          limit: itemsPerPage,
          sort_field: sortBy[0]? sortBy[0] : null,
          sort_dir: sortBy[0]? (sortDesc[0]? 'asc' : 'desc') : null,
          modality_ids: [this.activeModalityId],
          ...this.local_filter
        }
        if(this.search){
          params = {modality_ids: [this.activeModalityId], query: this.search}
        }
  
        Api.Driver.index({...params, index: true, external: true}).then(response => response.data).then(drivers => {
          if(reset_page){
            this.pagination.page = 1
          }
          this.all_drivers = drivers.data
          this.total_drivers = drivers.total
        }).catch(function(error) {
          console.log(error);
        }).finally(() => {
          this.loading = false
        });
      }
    },
    getAllStatuses(){
      this.indexStatuses()
    },
    editItem(item) {
      this.$router.push({name: 'EditDriver', params:{id: item.id}})
    },
    closeDialog(){
      this.dialog = false
      this.clearDriver()
    },
    ...mapActions({
      getOneDriver: 'Driver/show',
      clearDriver: 'Driver/clearDriver',
      indexStatuses: 'Status/index'
    })
  },
  mounted() {
    this.getAllStatuses()
  },

  watch: {
    pagination: {
      deep: true,
      handler(nv, ov) {
        if (!this.loading) {
          this.getDrivers()
        }
      },
    },
    local_filter(){
      this.getDrivers(true)
    }
  },
}
</script>

<style scoped>
.drivers-list-filters {
  width: 100%;
  flex: 1 1 100%;
  min-width: 0;
}
.drivers-list-filters >>> .filter-data-card {
  width: 100%;
}
</style>